/**
 * @privateRemarks we don't make use of fetchWithTimeout as it mocks itself out
 * to be a HTTP 400 - Which would be considered "online" in this case, whereas
 * we'd like to treat timeouts as offline
 */
export const isOnline = async (timeout = 1000) => {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const fetchWithTimeout = async (url: string) => {
    try {
      await fetch(url, {
        cache: 'no-cache',
        method: 'GET',
        signal: controller.signal,
      });
      return true;
    } catch (error) {
      if (
        // No internet connection will result in this type of error
        error instanceof TypeError ||
        // Timeout - We'll assume this means we're not connected although it could
        // be due to the server having trouble with responding
        (error instanceof Error && error.name === 'AbortError')
      ) {
        throw error; // Rethrow to let catch handle it
      }
      // If the error is not related to connectivity, assume online
      return true;
    }
  };

  try {
    // Fetching manifest.json from our CloudFront to check for network connectivity
    // Previously we were pinging https://canvas-workers.atlassian.com/healthcheck but have noticed some
    // issues with clients (mostly from hello.atlassian.net) losing connectivity
    // to the site due to network changes (potentially from VPN)
    // See: https://product-fabric.atlassian.net/browse/CNS-9746
    await fetchWithTimeout('/whiteboards/assets/manifest.json');

    clearTimeout(id);
    return true;
  } catch {
    // If all promises fail, we assume offline
    return false;
  } finally {
    clearTimeout(id);
  }
};
